export default "__VITE_ASSET__B9zZgh29__"